export enum EDITOR_TOOLBAR_TOOL_GROUP {
    text = 'text',
    layout = 'layout',
    media = 'media',
    embeddings = 'embeddings',
    expandAll = 'expand_all',
}
